import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html',
})
export class SubheaderComponent implements OnInit, AfterViewInit {
  @Input() SubheaderTitle: string;
  @Input() BreadcrumbTitle: string;
  @Input() BreadcrumbTitleSecond: string;
  @Input() Url: string;
  @Input() SecondUrl: string;

  @Input() ShowbreadCrumb: boolean;
  @Input() ShowToolbar: boolean = true;
  @Input() ShowBreadcrumbSecond: boolean;
 
  constructor() { }

  ngOnInit(): void {

  }
  ngAfterViewInit(): void {

  }

}


